export const MARKET_DATA_HEALTH_STATUS = {
  HEALTHY: 'HEALTHY',
  DEGRADED: 'DEGRADED',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const MARKET_DATA_HEALTH_FIELDS = [
  'marketDataHealth',
  'marketDataStatus',
  'marketDataHealthStatus',
  'marketDataEligibilityStatus',
];

const HEALTHY_VALUES = new Set([
  'healthy',
  'green',
  'ok',
  'available',
  'ready',
]);

const DEGRADED_VALUES = new Set([
  'degraded',
  'lagging',
  'amber',
  'warning',
  'warn',
  'delayed',
  'incomplete',
  'usable',
]);

const UNAVAILABLE_VALUES = new Set([
  'unavailable',
  'stale',
  'red',
  'error',
  'missing',
  'missing_candles',
  'missing candles',
  'no_credible_nbbo',
  'no credible nbbo',
  'failed',
  'down',
  'invalid',
]);

export const normalizeMarketDataHealthStatus = (value) => {
  if (value === null || value === undefined) return null;

  const normalizedValue = `${value}`.trim().toLowerCase();
  if (!normalizedValue) return null;

  if (HEALTHY_VALUES.has(normalizedValue)) {
    return MARKET_DATA_HEALTH_STATUS.HEALTHY;
  }
  if (DEGRADED_VALUES.has(normalizedValue)) {
    return MARKET_DATA_HEALTH_STATUS.DEGRADED;
  }
  if (UNAVAILABLE_VALUES.has(normalizedValue)) {
    return MARKET_DATA_HEALTH_STATUS.UNAVAILABLE;
  }

  return null;
};

export const extractTradePlanMarketDataHealth = (tradePlan) => {
  if (!tradePlan) {
    return {
      source: null,
      raw: null,
      status: null,
    };
  }

  for (const field of MARKET_DATA_HEALTH_FIELDS) {
    const raw = tradePlan[field];
    if (raw === null || raw === undefined || `${raw}`.trim() === '') {
      continue;
    }

    return {
      source: field,
      raw,
      status: normalizeMarketDataHealthStatus(raw),
    };
  }

  return {
    source: null,
    raw: null,
    status: null,
  };
};
